import {
    FilterInput,
    FilterItem,
    FilterValues,
    FilterWithChecked,
    IdNameItem,
    MenuPartItem,
    OtherFilter,
    RestaurantFilter
} from "@vms/SelectFilters/SelectFiltersTypes";

export function mapFiltersToApi(
    filters: FilterValues,
    countryCode: string,
    restaurantListId?: number,
    restaurantListName?: string
): FilterInput {
    const { venues, menuItems, attributes } = filters;

    const extractChecked = <T extends FilterWithChecked<IdNameItem>>(
        items: T[]
    ): FilterItem[] => {
        return items
            .filter((item) => item.isChecked)
            .map(({ id, name }) => ({ id, name }));
    };

    const restaurantFilters: RestaurantFilter = {
        restaurantListId,
        restaurantListName,
        segments: extractChecked(venues.segments),
        regions: extractChecked(venues.regions),
        cuisines: extractChecked(venues.cuisines),
        hostedLocations: extractChecked(venues.hostedLocations),
        dayParts: extractChecked(attributes.dayParts),
    };

    const menuPartFilterItems: MenuPartItem[] = [
        { id: 1, name: 'Appetizer', menuItemTypes: extractChecked(menuItems.appetizers) },
        { id: 2, name: 'Entree', menuItemTypes: extractChecked(menuItems.entrees) },
        { id: 3, name: 'Side', menuItemTypes: extractChecked(menuItems.sides) },
        { id: 4, name: 'Dessert', menuItemTypes: extractChecked(menuItems.desserts) },
        { id: 5, name: 'Beverage', menuItemTypes: extractChecked(menuItems.beverages) },
    ];

    const otherFilters: OtherFilter = {
        healthyDining: attributes.healthyTerms,
        smallPlates: attributes.smallPlates,
        kidMenus: attributes.kidMenus,
        glutenFree: attributes.glutenFree,
        plantBased: attributes.plantBased,
        catering: attributes.catering,
        minPrice: menuItems.minPrice,
        maxPrice: menuItems.maxPrice,
        minUnits: venues.minUnits === 1 ? null : venues.minUnits,
        maxUnits: venues.maxUnits,
        restaurants: venues.restaurants,
        customWords: menuItems.words,
        tags: attributes.tags,
    };

    return {
        countryCode,
        restaurantFilters,
        menuPartFilterItems,
        otherFilters,
    };
}